import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

export const MapContainer = styled(Box)`
  ${({ theme }) => css`
    width: 100%;
    height: 100vw;
    ${({ theme }) => css`
      padding-bottom: ${theme.spacing(4)};
    `}
    ${theme.media.md.up} {
      width: 100%;
      height: 400px;
    }
  `};
`;
